import { render } from "./Education.component.vue?vue&type=template&id=4717d20d"
import script from "./Education.component.vue?vue&type=script&lang=js"
export * from "./Education.component.vue?vue&type=script&lang=js"

import "./Education.component.vue?vue&type=style&index=0&id=4717d20d&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__